import React from 'react';
import { Card, Badge, Button, Icon, Divider } from '../../../components/ui';

export interface ShipmentComplete {
  type: 'shipment_complete';
  tracking_number: string;
  label_url: string;
  carrier: string;
  service: string;
  order_id?: string;
}

interface FinalShipmentCardProps {
  shipment: ShipmentComplete;
  onViewOrder?: () => void;
}

const FinalShipmentCard: React.FC<FinalShipmentCardProps> = ({ shipment, onViewOrder }) => {
  return (
    <Card pad style={{ maxWidth: 420, margin: '8px 0', border: '1px solid var(--ok)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <Icon name="checkCircle" size={16} style={{ color: 'var(--ok)' }} />
        <strong style={{ color: 'var(--ok)' }}>Shipment Created</strong>
      </div>

      <Divider style={{ marginBottom: 12 }} />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span className="muted" style={{ minWidth: 80, fontSize: 13 }}>Tracking:</span>
          <Badge tone="info" style={{ fontFamily: 'monospace', fontWeight: 600 }}>
            {shipment.tracking_number}
          </Badge>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <span className="muted" style={{ minWidth: 80, fontSize: 13 }}>Carrier:</span>
          <span style={{ fontWeight: 500, fontSize: 13 }}>{shipment.carrier}</span>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <span className="muted" style={{ minWidth: 80, fontSize: 13 }}>Service:</span>
          <span style={{ fontWeight: 500, fontSize: 13 }}>{shipment.service}</span>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 10 }}>
        {shipment.label_url && (
          <a
            href={shipment.label_url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
            style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}
          >
            <Icon name="download" size={14} />
            Download Label
          </a>
        )}
        {onViewOrder && (
          <Button variant="secondary" onClick={onViewOrder} style={{ flex: 1 }}>
            <Icon name="external" size={14} style={{ marginRight: 6 }} />
            View Order
          </Button>
        )}
      </div>
    </Card>
  );
};

export default FinalShipmentCard;
